export default __webpack_public_path__ + "static/media/Fall_15.94b84cf7.png";